// extracted by mini-css-extract-plugin
export default {"root":"content_root__lx1Oz","mainSectionContent__grow":"content_mainSectionContent__grow__tRkgu","htmlContentContainer":"content_htmlContentContainer__+8jGf"};